import * as React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import PDFCompanyHeader from "./PDFCompanyHeader";
import PDFCompanyFooter from "./PDFCompanyFooter";
Font.register({
  src: "https://fonts.gstatic.com/s/kadwa/v2/rnCm-x5V0g7ipiTAT8M.ttf",
  family: "KadwaRegular",
});
Font.register({
  src: "https://fonts.gstatic.com/s/kadwa/v2/rnCr-x5V0g7ipix7atM5kn0.ttf",
  family: "KadwaBold",
});
Font.register({
  src:
    "https://fonts.gstatic.com/s/montserrat/v12/JTUSjIg1_i6t8kCHKm459Wlhzg.ttf",
  family: "MontserratRegular",
});
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    // backgroundColor: "#E4E4E4"
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  body: {
    padding: 10,
  },
  table: {
    display: "flex",
    width: "auto",
    margin: 20,
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 8,
    fontWeight: 500,
  },
  tableCell: {
    margin: 5,
    fontSize: 8,
  },
});
function PDFTableComponents(props: any) {
  const getDataForEachPage = (rawData: any) => {
    let dataForPage = new Array<any>();
    let numPage = rawData.length / 8;
    let start = 0;
    for (var i = 0; i < numPage; i++) {
      let pageData = new Array<any>();
      for (var j = start; j < rawData.length; j++) {
        if (pageData.length < 8) {
          pageData.push(rawData[j]);
          start = j;
        }
      }
      dataForPage.push({ items: pageData });
    }
    return dataForPage;
  };

  const getObjectFromKey = (obj: any, keyVar: any) => {
    let objValue = null;
    Object.entries(obj).map(([key, value]) => {
      if (key === keyVar) {
        objValue = value; //Object.fromEntries(Object.entries(obj));
      }
      return null;
    });
    return objValue;
  };
  const { company, columns, data, createData } = props;
  let dataForPage = getDataForEachPage(data);
  return (
    <Document>
      {dataForPage.map((dataItem: any, index: any) => (
        <Page
          size="A4"
          orientation={"landscape"}
          style={styles.page}
          wrap={false}
        >
          {company && company.name && <PDFCompanyHeader company={company} />}
          <View style={styles.table}>
            <View style={styles.tableRow}>
              {columns.map((headerItem: any) => {
                if (headerItem.isSeachable) {
                  return (
                    <View style={styles.tableColHeader}>
                      <Text style={styles.tableCellHeader}>
                        {headerItem.label}
                      </Text>
                    </View>
                  );
                }
                return null;
              })}
            </View>
            {dataItem.items.map((pageData: any, index: any) => {
              let columnData = createData(pageData);
              return (
                <View style={styles.tableRow}>
                  {columns.map((column: any) => {
                    if (column.isSeachable) {
                      const value = getObjectFromKey(columnData, column.id);
                      return (
                        <View style={styles.tableCol}>
                          <Text style={styles.tableCell}>{value}</Text>
                        </View>
                      );
                    }
                    return null;
                  })}
                </View>
              );
            })}
          </View>
          <PDFCompanyFooter />
        </Page>
      ))}
    </Document>
  );
}
export default PDFTableComponents;
